

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class IntegratorMapping_ManagedObject

class IntegratorMapping_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: userInfo
    set userInfo(value:any) {
        this.setValueForKey(value, 'userInfo');
    }
    get userInfo():any {
        return this.valueForKey('userInfo');
    }
    set userInfoPrimitiveValue(value:any) {
        this.setPrimitiveValueForKey(value, 'userInfo');
    }
    get userInfoPrimitiveValue():any {
        return this.primitiveValueForKey('userInfo');
    }
}
